module.exports = __webpack_public_path__ + "static/media/icon-merchandise.7d938e08.svg";